import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl'
import moment from 'moment'
import { range, each, map, cloneDeep, find } from 'lodash'
import $ from 'jquery'; 

import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import HelpAlert from '../components/HelpAlert'

import { Pie } from 'react-chartjs-2'
import { Select, Row, Col, Spin, message } from 'antd'
const { Option } = Select


class Report3 extends Component {

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        year: moment().year(),
        data: null,
        loading: false
    }

    fetch = () => {
        const { intl, comboboxes } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'reports/3/' + this.state.year 
        }).then((data) => {
            each(data.byLaboratory, laboratory => {
                laboratory.name = comboboxes.byKey["laboratory"][laboratory.laboratory].value
            })
            this.setState({
                data: data,
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    componentDidUpdate() {
        const { loading, data, year } = this.state
        if (!loading && data) {
            const total = find(data.byYear, { year: "" + year })
            if (total) {
                let tfoot = '<tfoot class="ant-table-thead"><tr><th>Total</th>'
                each(moment.months(), (month, index) => (
                    tfoot += '<th>' + (total.items[index + 1] || 0) + '</th>'
                ))
                tfoot += "<th>" + total.total + "</th></tr></tfoot>"
                $(".table-laboratories table").append(tfoot)
            }
        }
    }

    onChangeYear = (value) => {
        this.setState({ year: value }, this.fetch)
    }

    render() {
        const { loading, data, year } = this.state
        const { intl } = this.props
        if (loading || !data) {
            return <Spin />
        }

        /**
         * Default chart values
         */
        const chartColors = ['rgb(255, 99, 132)', 'rgb(255, 159, 64)', 'rgb(255, 205, 86)', 'rgb(75, 192, 192)','rgb(54, 162, 235)', 'rgb(153, 102, 255)', 'rgb(201, 203, 207)'];
        var chartConfig = {
            responsive: true,
            title: {
                display: true,
                text: 'Title'
            }
        }

        /**
         * Chart 1
         */
        while (chartColors.length < data.doctors.length) {
            chartColors.push('#' + Math.floor(Math.random() * 16777215).toString(16))
        }
        const chart1Data = {
            labels: map(data.doctors, doctor => this.props.comboboxes.byKey['country'][doctor.country].value),
            datasets:[{
                label: "Dataset 1",
                backgroundColor: chartColors,
                data: map(data.doctors, 'count')
            }]  
        }
        const chart1Config = cloneDeep(chartConfig)
        chart1Config.title.text = intl.formatMessage({id: 'reports.report3.chart1.title'})

        /**
         * Chart 2
         */
        const chart2Data = {
            labels: map(data.bloodTests, bt => this.props.comboboxes.byKey['country'][bt.country].value),
            datasets:[{
                label: "Dataset 1",
                backgroundColor: chartColors,
                data: map(data.bloodTests, 'count')
            }]  
        }
        const chart2Config = cloneDeep(chartConfig)
        chart2Config.title.text = intl.formatMessage({id: 'reports.report3.chart2.title'})

        return (
            <div>
                <h1><FaIcon icon="chart-bar" fixedWidth /> <FormattedHTMLMessage id="reports.report3.title" /></h1>
                <div className="action-bar">
                    <Select defaultValue={year} style={{ width: 120 }} onChange={this.onChangeYear}>
                        { range(2016, moment().year() + 1).map(year => <Option key={year} value={year}>{year}</Option>) }
                    </Select>
                </div>
                <Row gutter={24}>
                    <Col xl={12}>
                        <HelpAlert style={{ marginBottom: '25px' }} message="reports.report3.chart1.helpAlert" />
                        <Pie data={chart1Data} options={chart1Config} />
                    </Col>
                    <Col xl={12}>
                        <HelpAlert style={{ marginBottom: '25px' }} message="reports.report3.chart2.helpAlert" />
                        <Pie data={chart2Data} options={chart2Config} />
                    </Col>
                </Row>
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default injectIntl(connect(mapStateToProps)(Report3))


// WEBPACK FOOTER //
// ./src/views/Report3.js